import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import nivioLogo from '../assets/nivio-logo.png';
import { type Branding, DEFAULT_BRANDING } from '../branding';

export type { Branding } from '../branding';
export { DEFAULT_BRANDING } from '../branding';

/**
 * The brand row of the mockup: the 15px NIVIO logo followed by the product name in Baskerville
 * italic. A customer brand replaces the NIVIO logo and keeps a "Powered by NIVIO" line.
 */
export function BrandIdentity({
  branding = DEFAULT_BRANDING,
  product,
  version,
  homeTo,
  onHomeClick,
}: {
  branding?: Branding | undefined;
  product: string;
  version?: ReactNode;
  align?: 'start' | 'center';
  /** Makes the logo and product name a link to this route. */
  homeTo?: string;
  onHomeClick?: () => void;
}) {
  // A company name of NIVIO is the default brand, not a customer brand.
  const customer =
    Boolean(branding.companyName) && branding.companyName?.trim().toUpperCase() !== 'NIVIO';
  const name = branding.companyName || 'NIVIO';
  const mark = customer ? (
    branding.logoDataUrl ? (
      <img src={branding.logoDataUrl} alt="" className="nv-logo nv-logo-brand" />
    ) : (
      <span className="nv-brand-name">{name}</span>
    )
  ) : (
    <img className="nv-logo" src={nivioLogo} alt="NIVIO" />
  );
  const row = (
    <>
      {mark}
      <span className="nv-prod">{product}</span>
    </>
  );
  return (
    <div className="nv-brandwrap">
      <div className="nv-brand">
        {homeTo ? (
          <Link
            to={homeTo}
            className="nv-brandlink"
            aria-label={`${name} ${product}`}
            {...(onHomeClick ? { onClick: onHomeClick } : {})}
          >
            {row}
          </Link>
        ) : (
          row
        )}
        {version}
      </div>
      {customer && <div className="nv-brandpowered">Powered by NIVIO</div>}
    </div>
  );
}
